import { Box } from '@mui/material';
import PolicyDrawer from '../../../../console/policies/drawers/policyholder/PolicyDrawer';
import { PolicyHolderPolicyDrawerHeader } from '../../../../console/policies/drawers/policyholder/PolicyHolderPolicyDrawerHeader';
import PolicyHolderPolicySummary from '../../../../console/policies/drawers/policyholder/PolicyHolderPolicySummary';
import type { Source } from '../../types';
import { PolicyHolderCoverageBlocks } from './PolicyHolderCoverageBlocks';

interface Props {
  readonly open: boolean;
  readonly source: Source | null;
  readonly onClose: () => void;
}

export function PolicyOverlayDrawer({ open, source, onClose }: Props) {
  if (!source) return null;

  const meta = (source.metadata ?? {}) as Record<string, unknown>;
  const policyId = (meta.objectId || meta.policyNumber) as string;
  const product = meta.productType as string;

  return (
    <PolicyDrawer
      policyId={policyId}
      product={product}
      open={open}
      onClose={onClose}
    >
      {({ policy = {}, isError }: any) => {
        if (isError) return <>Policy details missing!</>;
        const merged = { ...meta, ...policy };
        return (
          <>
            <PolicyHolderPolicyDrawerHeader policy={merged} />
            <Box mt={2} style={{ overflowY: 'auto', overflowX: 'hidden' }}>
              <PolicyHolderPolicySummary
                policy={merged}
                closeDrawer={onClose}
              />
              <PolicyHolderCoverageBlocks
                product={product}
                coverages={policy.coverages}
                policy={policy}
              />
            </Box>
          </>
        );
      }}
    </PolicyDrawer>
  );
}
